import type {
  CreateFormTemplateQuestionDraft,
  CreateFormTemplateRequest,
  FormTemplate,
} from '../../models/TaskForm/TaskForm';
import { getTemplateQuestionsInDisplayOrder } from './useTemplateQuestions';
import { toCreateFormTemplateRequest } from './templatePayload';

export const getCopiedTemplateQuestionDrafts = (
  template: FormTemplate,
): CreateFormTemplateQuestionDraft[] =>
  getTemplateQuestionsInDisplayOrder(template).map((question, index) => ({
    order: index + 1,
    question: question.question?.value ?? '',
    restriction: question.restriction,
  }));

export const getCopiedTemplateName = (
  template: FormTemplate,
  managementTemplates: readonly FormTemplate[],
): string => {
  const baseName = `${template.name ?? 'Анкета'}_копия`;
  const existingNames = new Set(
    managementTemplates
      .map((managementTemplate) => managementTemplate.name)
      .filter((name): name is string => Boolean(name)),
  );

  if (!existingNames.has(baseName)) {
    return baseName;
  }

  let suffix = 2;
  let nextName = `${baseName} ${suffix}`;

  while (existingNames.has(nextName)) {
    suffix += 1;
    nextName = `${baseName} ${suffix}`;
  }

  return nextName;
};

export const buildCopiedTemplateRequest = (
  template: FormTemplate,
  managementTemplates: readonly FormTemplate[],
): CreateFormTemplateRequest =>
  toCreateFormTemplateRequest(
    getCopiedTemplateName(template, managementTemplates),
    getCopiedTemplateQuestionDrafts(template),
  );
